import React, { useRef, useEffect } from 'react';
import Highcharts from 'highcharts/highmaps';
import useRecoleccionNfuPorProvincia from '../../../hooks/administrador/general/useRecoleccionNfuProvincia';
import '../../../styles/administrador.css';

 
import ecuadorMap from '@highcharts/map-collection/countries/ec/ec-all.geo.json';

const RecoleccionNfuProvincia = ({ year, mes, token, idAdministrador }) => {
  const chartRef = useRef(null);
  const { data, loading, error } = useRecoleccionNfuPorProvincia(year, mes, token, idAdministrador);
  
   
  Highcharts.maps['countries/ec/ec-all'] = ecuadorMap;

  useEffect(() => {
    if (!loading && data && Array.isArray(data) && data.length > 0 && chartRef.current) {
       
      const provinceMap = {
        'Azuay': 'ec-az',
        'Bolívar': 'ec-bo',
        'Cañar': 'ec-cn',
        'Carchi': 'ec-cr',
        'Chimborazo': 'ec-cb',
        'Cotopaxi': 'ec-ct',
        'El Oro': 'ec-eo',
        'Esmeraldas': 'ec-es',
        'Galápagos': 'ec-ga',
        'Guayas': 'ec-gu',
        'Imbabura': 'ec-im',
        'Loja': 'ec-lj',
        'Los Ríos': 'ec-lr',
        'Manabí': 'ec-mn',
        'Morona Santiago': 'ec-ms',
        'Napo': 'ec-1076',
        'Orellana': 'ec-na',
        'Pastaza': 'ec-pa',
        'Pichincha': 'ec-pi',
        'Santa Elena': 'ec-se',
        'Santo Domingo de los Tsáchilas': 'ec-sd',
        'Sucumbíos': 'ec-su',
        'Tungurahua': 'ec-tu',
        'Zamora Chinchipe': 'ec-zc'
      };

      const regionMap = {
        'ec-es': 'costa',
        'ec-mn': 'costa',
        'ec-gu': 'costa',
        'ec-se': 'costa',
        'ec-eo': 'costa',
        'ec-lr': 'costa',
        'ec-sd': 'costa',

        'ec-cr': 'sierra',
        'ec-im': 'sierra',
        'ec-pi': 'sierra',
        'ec-ct': 'sierra',
        'ec-tu': 'sierra',
        'ec-bo': 'sierra',
        'ec-cb': 'sierra',
        'ec-cn': 'sierra',
        'ec-az': 'sierra',
        'ec-lj': 'sierra',

        'ec-su': 'amazonia',
        'ec-1076': 'amazonia',
        'ec-na': 'amazonia',
        'ec-pa': 'amazonia',
        'ec-ms': 'amazonia',
        'ec-zc': 'amazonia',

        'ec-ga': 'insular'
      };

      const colorOptions = {
        option1: {
          costa: '#BBD03D',
          sierra: '#849D0F',
          amazonia: '#9EB61E',
          insular: '#BBD03D'
        },
      };

      const colorScheme = colorOptions.option1;

       
      const formattedData = data.map(provincia => {
        const hcKey = provinceMap[provincia.name] || null;
        if (!hcKey) {
          return null;
        }

        let detalles;
        try {
          detalles = JSON.parse(provincia.details);
          if (Array.isArray(detalles)) {
            const detallesUnificados = {};

            detalles.forEach(detalle => {
              const clave = (detalle.name === 'PLT' || detalle.name === 'PLT 2') ? 'PLT' : detalle.name;

              if (!detallesUnificados[clave]) {
                detallesUnificados[clave] = {
                  name: clave,
                  value: 0
                };
              }

              detallesUnificados[clave].value += parseInt(detalle.value) || 0;
            });

            detalles = Object.values(detallesUnificados);
          }

          provincia.details = JSON.stringify(detalles);
        } catch (e) {
           
        }

        const region = regionMap[hcKey] || 'default';
        const color = colorScheme[region] || '#E0E0E0';

        return {
          "hc-key": hcKey,
          value: parseFloat(provincia.value) || 0,
          name: provincia.name,
          details: provincia.details,
          color: color
        };
      }).filter(item => item !== null);

       
      let totalNFU = 0;
      formattedData.forEach(provincia => {
        try {
          const detalles = JSON.parse(provincia.details);
          if (Array.isArray(detalles)) {
            detalles.forEach(detalle => {
              totalNFU += parseInt(detalle.value) || 0;
            });
          }
        } catch (e) {
           
        }
      });

       
      const legendItems = [
        { name: 'Costa', color: colorScheme.costa },
        { name: 'Sierra', color: colorScheme.sierra },
        { name: 'Amazonía', color: colorScheme.amazonia },
        { name: 'Insular', color: colorScheme.insular }
      ];

       
      const options = {
        chart: {
          map: 'countries/ec/ec-all'
        },
        title: {
          text: 'Mapa de entrega de NFU por provincia'
        },
        subtitle: {
          text: `TOTAL RECOLECTADOS: ${totalNFU.toLocaleString()} [U]`,
          style: {
            fontWeight: 'bold',
            fontSize: '12px',
          }
        },
        legend: {
          enabled: false,
        },
        mapNavigation: {
          enabled: false,
          buttonOptions: {
            verticalAlign: 'bottom'
          }
        },
        credits: {
          enabled: false
        },
        colorAxis: {
          min: 0,
          minColor: '#CCE27A',
          maxColor: '#9EB61E',
          visible: false
        },
        series: [
          {
            name: 'Cantidad Recolectada',
            data: formattedData,
            joinBy: ['hc-key', 'hc-key'],
            states: {
              hover: {
                color: '#FFCC00'
              },
              select: {
                color: '#FFCC00'
              }
            },
            dataLabels: {
              enabled: true,
              format: '{point.name}',
              style: {
                textOutline: '1px white',
                fontWeight: 'normal'
              }
            },
            tooltip: {
              confine: true,
              pointFormatter: function() {
                let details;
                try {
                  details = JSON.parse(this.details);
                } catch (e) {
                   
                  return `<b>${this.name}</b>: <br>Error al parsear detalles.`;
                }

                const order = ['PLT', 'CVT', 'OTR', 'MOT', 'BICI'];
                details.sort((a, b) => order.indexOf(a.name) - order.indexOf(b.name));

                let detailsString = details.map(d => `<b>${d.name}:</b> ${d.value.toLocaleString()} [U]`).join('<br>');
                let total = details.reduce((sum, d) => sum + d.value, 0).toLocaleString();

                const hcKey = this['hc-key'];
                const region = regionMap[hcKey] || 'No definida';
                const regionName = region.charAt(0).toUpperCase() + region.slice(1);

                return `<b>${this.name}</b> (${regionName}): <br>${detailsString}<br><b>Total: ${total} [U]</b>`;
              }
            }
          },
          {
            name: 'Regiones',
            type: 'mapline',
            data: legendItems.map((item, index) => ({
              name: item.name,
              color: item.color
            })),
            showInLegend: true,
            enableMouseTracking: false,
            linkedTo: ':previous'
          }
        ]
      };

       
      Highcharts.mapChart(chartRef.current, options);

       
      return () => {
        if (chartRef.current) {
          const chart = Highcharts.charts.find(
            chart => chart && chart.renderTo === chartRef.current
          );
          if (chart) {
            chart.destroy();
          }
        }
      };
    }
  }, [data, loading]);

  if (loading) {
    return <div className="grafica loading">Cargando mapa...</div>;
  }

  if (error || !data || data.length === 0) {
    return <div className="grafica error">No hay datos disponibles para el mapa</div>;
  }

  return <div className='grafica' ref={chartRef}></div>;
};

export default RecoleccionNfuProvincia;